"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editRequestSchema = void 0;
const zod_1 = require("zod");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const Keyword_1 = require("../../types/Keyword");
const Reason_1 = require("../../types/Reason");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const uniqueForCustomizableValue_1 = require("../../../common/schemas/helpers/uniqueForCustomizableValue");
const uniqueForIdValue_1 = require("../../../common/schemas/helpers/uniqueForIdValue");
const selectedItemWithSpecificTypeOrCustomName_schema_1 = require("../../../common/schemas/selectedItemWithSpecificTypeOrCustomName.schema");
const amountWithCurrency_schema_1 = require("../common/amountWithCurrency.schema");
exports.editRequestSchema = zod_1.z
    .object({
    version: zod_1.z.string(),
    subject: subjectField_schema_1.subjectFieldSchema.optional(),
    description: zod_1.z.string().optional().nullable(),
    dueDate: datetime_schema_1.datetimeSchema.optional().nullable(),
    reopenedDate: datetime_schema_1.datetimeSchema.optional().nullable(),
    number: shortField_schema_1.shortFieldSchema.optional().nullable(),
    reasons: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Reason_1.Reason)
        .array()
        .refine(...(0, uniqueForIdValue_1.uniqueForIdValue)(uniqueForCustomizableValue_1.uniqueReasonsMessage))
        .optional(),
    disciplines: selectedItem_schema_1.selectedItemSchema
        .array()
        .refine(...(0, uniqueForIdValue_1.uniqueForIdValue)(uniqueForCustomizableValue_1.uniqueDisciplinesMessage))
        .optional(),
    keywords: (0, selectedItemWithSpecificTypeOrCustomName_schema_1.selectedItemWithSpecificTypeOrCustomNameSchema)(Keyword_1.Keyword)
        .array()
        .refine(...(0, uniqueForCustomizableValue_1.uniqueForCustomizableValue)(uniqueForCustomizableValue_1.uniqueKeywordsMessage))
        .optional(),
    receivedVia: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia).optional(),
    receivedDate: datetime_schema_1.datetimeSchema.optional(),
    senderNumber: shortField_schema_1.shortFieldSchema.optional().nullable(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional().nullable(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional().nullable(),
})
    .strict();
//# sourceMappingURL=editRequest.schema.js.map